import React from "react";
import NotFound from "./NotFound";
import Header from "../Header/Header";
import Footer from "../../components/Footer/OuterFooter";

const NotFoundPage = () => {
  return (
    <div className="education-page">
      <Header />
      <NotFound />
      <Footer />
    </div>
  );
};

export default NotFoundPage;
